import React, {FC} from 'react';
import {Button} from '@mui/material';
import {observer} from "mobx-react";
import {useStorageUserConfigContext} from "@app/modules/UserConfig/contexts/storage";


type TProps = {
}

export const SaveUser: FC<TProps> = observer((props: TProps) => {

    const {userConfigStore} = useStorageUserConfigContext();


    let disabled = userConfigStore.userLogin == '' || userConfigStore.userPassword == ''

    return (
        <Button
            variant={"contained"}
            disabled={disabled}
            type={"submit"}
        >
            Create account
        </Button>
    )

})
